var exports = {
  "L": "x93eb46d8--22fde1--carousel-container",
  "D": "x93eb46d8--22fde1--carousel",
};

module.exports = exports;
